import { Box, Typography } from '@mui/material';
import { useContext } from 'react';
import '../template.module.css';
import BlockNameHeading from './BlockNameHeading';

import { ReportTemplatesContext } from '..';
import { RemoveBlockSVG } from './HelperSVGs';

export function SchoolDistrictNameBlock() {
  const { removeBlock } = useContext(ReportTemplatesContext);
  return (
    <Box
      sx={{
        flex: 1,
        backgroundColor: '#F9F9F9',
        paddingY: '1.25rem',
        paddingX: '3.5rem',
        borderRadius: '1rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.75rem',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: '.5rem',
          alignItems: 'center',
        }}
      >
        <BlockNameHeading title='School District Name' />
      </Box>
      <Typography
        sx={{
          fontFamily: 'Lato',
          fontSize: '1.25rem',
          fontWeight: 500,
          lineHeight: '20px',
          textAlign: 'center',
        }}
      >
        Hillsborough
      </Typography>
      <Box
        sx={{
          cursor: 'pointer',
        }}
        onClick={() => {
          removeBlock('School District Name', 'schools');
        }}
      >
        <RemoveBlockSVG />
      </Box>
    </Box>
  );
}

export function NearestThreeSchoolsBlock() {
  const { removeBlock } = useContext(ReportTemplatesContext);
  const style = {
    colorBox: {
      height: '1rem',
      width: '1rem',
    },
    schoolBox: {
      display: 'flex',
      gap: '1.25rem',
      alignItems: 'center',
    },
    schoolTitle: {
      fontFamily: 'Lato',
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: '20px',
      textAlign: 'left',
      textDecoration: 'underline',
    },
  };

  return (
    <Box
      sx={{
        flex: 1,
        backgroundColor: '#F9F9F9',
        paddingY: '1.25rem',
        paddingX: '3.5rem',
        borderRadius: '1rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          paddingX: '1rem',
          paddingY: '1.5rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '2rem',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '.5rem',
            alignItems: 'center',
          }}
        >
          <BlockNameHeading title='Nearest Three Schools' />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
          }}
        >
          <Box sx={style.schoolBox}>
            <Box
              sx={[
                style.colorBox,
                {
                  backgroundColor: '#FF5733',
                },
              ]}
            />
            <Typography sx={style.schoolTitle}>School One</Typography>
          </Box>
          <Box sx={style.schoolBox}>
            <Box
              sx={[
                style.colorBox,
                {
                  backgroundColor: '#33FF57',
                },
              ]}
            />
            <Typography sx={style.schoolTitle}>School Two</Typography>
          </Box>
          <Box sx={style.schoolBox}>
            <Box
              sx={[
                style.colorBox,
                {
                  backgroundColor: '#3357FF',
                },
              ]}
            />
            <Typography sx={style.schoolTitle}>School Three</Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          cursor: 'pointer',
        }}
        onClick={() => {
          removeBlock('Nearest 3 Schools', 'schools');
        }}
      >
        <RemoveBlockSVG />
      </Box>
    </Box>
  );
}
